import { render } from "./container_base.vue?vue&type=template&id=6dcadd13"
import script from "./container_base.vue?vue&type=script&lang=js"
export * from "./container_base.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/container_base.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6dcadd13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6dcadd13', __exports__)) {
    console.log('reload')
    api.reload('6dcadd13', __exports__)
  }
  
  module.hot.accept("./container_base.vue?vue&type=template&id=6dcadd13", () => {
    console.log('re-render')
    api.rerender('6dcadd13', render)
  })

}


export default __exports__